import { colors } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

export const useStyles = (): IStyles => ({
  root: {
    margin: 0,
    padding: 0,
    width: 'auto',
    height: 'auto',
    '& svg': {
      color: colors.black,
      fontSize: 16,
    },
  },
});
